import React from 'react'

import { Button, Box } from '@mui/material'

const ButtonComponent = ({ label, hide, isActive, ...rest }) => {
  if (hide) return (null)
  const variant = isActive ? 'outlined' : 'contained'
  return (
    <Button sx={{ textTransform: 'none' }} size='small' variant={variant} {...rest} >
      {label}
    </Button>
  )
}

const OrderFilterButtons = ({ actions }) => (
  <Box flexDirection='row' gap={2}>
    <Box display='flex' flexDirection='row' gap={2} ml={1}>
      {_.map(actions, (action, index) => (<ButtonComponent key={index} {...action} />))}
    </Box>
  </Box>
)

export default React.memo(OrderFilterButtons)
